module.exports = "https://cdn2-fs.clearscore.com/flux/images/de7612faffc8486846f1a24c3840f9d8.jpg";